// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2uecF","overflowing":"ReadFullNote_overflowing__2_F1x"};